import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { http } from "wagmi";
import { mainnet, sepolia, hardhat } from "wagmi/chains";

// Custom localhost chain configuration
const localhost = {
  ...hardhat,
  id: 1337,
  name: "Localhost",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH",
  },
  rpcUrls: {
    default: { http: ["http://127.0.0.1:8545"] },
  },
} as const;

// Determine which chains to use based on environment
const isDev = import.meta.env.DEV;

// Public Sepolia RPC for read-only access (no wallet required).
// Keyless endpoint so it can ship in the client bundle. rpc.sepolia.org was
// retired (404), which silently broke hosted reads; publicnode is current.
// Override with VITE_SEPOLIA_RPC_URL for a dedicated (rate-limited) endpoint.
const SEPOLIA_PUBLIC_RPC = "https://ethereum-sepolia-rpc.publicnode.com";

export const config = getDefaultConfig({
  appName: "EtherMarket",
  projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || "demo",
  // Sepolia first in production since that's where contracts are deployed
  chains: isDev ? [localhost, sepolia, mainnet] : [sepolia, mainnet],
  transports: {
    [localhost.id]: http(),
    [sepolia.id]: http(import.meta.env.VITE_SEPOLIA_RPC_URL || SEPOLIA_PUBLIC_RPC),
    [mainnet.id]: http(import.meta.env.VITE_MAINNET_RPC_URL),
  },
});

// Export chain IDs for easy reference
export const CHAIN_IDS = {
  LOCALHOST: 1337,
  SEPOLIA: 11155111,
  MAINNET: 1,
} as const;

// Get the current network based on environment
export const getCurrentChainId = () => {
  if (isDev) return CHAIN_IDS.LOCALHOST;
  return CHAIN_IDS.MAINNET;
};
